import Head from 'next/head';
import React, { PureComponent } from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import Breadcrumb from '../../src/components/Breadcrumb';
import { Container } from '../../src/components/Grid';
import Header from '../../src/components/Header';
import { Main, Page } from '../../src/components/Layout';
import Watermark from '../../src/components/Parallax/Watermark';
import { withI18N } from '../../src/hoc/index';
import Introduction from './Introduction';
import Story from './Story';

class Application extends PureComponent {
  render() {
    const { t } = this.props;
    return (
      <Page application>
        <Head>
          <title key="title">Grand Hôtel-Dieu</title>
        </Head>
        <Header
          title={t('common:nav.menu.application')}
          image={`/static/images/application/header.jpg`}
        />
        <Main>
          <Container>
            <Breadcrumb
              items={[
                { href: '/', label: t('common:nav.tabs.home') },
                { label: t('common:nav.menu.application') }
              ]}
            />
          </Container>
          <Introduction />
          <Story />
        </Main>
      </Page>
    );
  }
}

export default withI18N()(Application);
